import { getCDNImageUrl } from '@/helpers/cdn';

export const BONUS_CLAIM_PRELOAD_URLS = [
  getCDNImageUrl('/lp/bonusClaim/bg.webp'),
  getCDNImageUrl('/lp/bonusClaim/left-img.webp'),
  getCDNImageUrl('/lp/bonusClaim/right-img.webp'),
  getCDNImageUrl('/lp/bonusClaim/main-mob-img.webp'),
  getCDNImageUrl('/lp/bonusClaim/icon-1.webp'),
  getCDNImageUrl('/lp/bonusClaim/icon-2.webp'),
];

export const parseNameFlags = (name: string) => {
  const lower = name.toLowerCase();

  return {
    dark: lower.includes('-dark'),
  };
};

export const getRegModalTheme = (name: string): string => {
  const { dark } = parseNameFlags(name);

  if (name === 'providers-modal-dark') return 'darkleProviders';
  if (name === 'games-modal-dark') return 'darkleGames';

  return dark ? 'dark' : 'default';
};
